import { render, staticRenderFns } from "./EcertValidation.vue?vue&type=template&id=10039250&scoped=true"
import script from "./EcertValidation.vue?vue&type=script&lang=js"
export * from "./EcertValidation.vue?vue&type=script&lang=js"
import style0 from "./EcertValidation.vue?vue&type=style&index=0&id=10039250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10039250",
  null
  
)

export default component.exports